/* eslint-disable no-unused-vars */

import React, { useState } from 'react'

const Wind2GenerationRect = ({
  data,
  xScale,
  limit,
  yScale,
  margin,
  days,
  height,
  selectedEventNum,
  traslateWidth = 10,
}) => {
  return (
    <g id="bluegreen">
      <g id="blue">
        {data.map((d, idx) => (
          <rect
            daySeqNo={d.daySeqNo}
            expectedgen={d.expectedGen}
            key={idx}
            x={xScale(parseFloat(d.daySeqNo)) + traslateWidth}
            y={yScale(d.expectedGen)}
            height={yScale(0) - yScale(d.expectedGen)}
            width={10}
            eventnum={d.eventNum}
            style={{
              fill: `rgb(${0},${0},${255})`,
            }}
          />
        ))}
      </g>
      <g id="green">
        {data.map((d, idx) => (
          <rect
            daySeqNo={d.daySeqNo}
            grossactgen={d.grossactgen}
            key={idx}
            x={xScale(parseFloat(d.daySeqNo)) + traslateWidth}
            y={yScale(d.grossactgen)}
            height={yScale(0) - yScale(d.grossactgen)}
            width={10}
            eventNum={d.eventNum}
            style={{
              fill: `rgb(${0},${255},${0})`,
            }}
          />
        ))}
      </g>
    </g>
  )
}

export default Wind2GenerationRect
